import { render, staticRenderFns } from "./ReviewCellComponent.vue?vue&type=template&id=461ba58f&scoped=true&"
import script from "./ReviewCellComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewCellComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCellComponent.vue?vue&type=style&index=0&id=461ba58f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ba58f",
  null
  
)

export default component.exports